import { Coleccionista } from './../../../../models/fichaRegistro.model';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { DetalleBienCulturalService } from '../../bienes-culturales/detalle-bien-cultural/detalle-bien-cultural.service';
import { BienesCulturalesService } from '../../bienes-culturales/bienes-culturales-list/bienes-culturales.service';
import { ColeccionistasService } from '../coleccionistas.service';

@Injectable({ providedIn: 'root' })
export class DetalleColeccionistaResolver implements Resolve<any> {
    
    constructor(
        private bienesCulturalesService: BienesCulturalesService,
        private coleccionistasService: ColeccionistasService
    ){}

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const coleccionistaId = route.paramMap.get('coleccionistaId');
        const coleccionistaUuid = route.paramMap.get('coleccionistaUuid');
        const params={inicio:0, max:10, coleccionista:coleccionistaId}
        
        this.bienesCulturalesService.bienesCulturealesFilterParmas = params
        return forkJoin([
            this.bienesCulturalesService.getFichaRegistro(params),
            this.coleccionistasService.getColeccionitaPorUuid(coleccionistaUuid),
            this.coleccionistasService.getBitacoraColeccionista(coleccionistaUuid)
        ])
    }
}